import { render, staticRenderFns } from "./staff_block_date.vue?vue&type=template&id=50317be8&"
import script from "./staff_block_date.vue?vue&type=script&lang=js&"
export * from "./staff_block_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports